import { render } from "./EditGeneral.vue?vue&type=template&id=2c9ab5ca&scoped=true"
import script from "./EditGeneral.vue?vue&type=script&lang=js"
export * from "./EditGeneral.vue?vue&type=script&lang=js"

import "./EditGeneral.vue?vue&type=style&index=0&id=2c9ab5ca&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9ab5ca"]])

export default __exports__